<template>
  <div id="content" class="d-flex">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'Content'
  }
</script>

<style lang="scss">
  #content {
    flex-direction: column;
    width: calc(100% - 333px);
    @media (max-width: 992px) {
      width: calc(100% - 105px);
    }
  }

</style>